import { styled } from '@mui/material/styles';
import { Column, Row } from 'components/Layout';

type Props = {
  icon: React.ReactNode;
  primaryLabel: React.ReactNode;
  secondaryLabel: React.ReactNode;
  actions: React.ReactNode;
};

const Card = styled(Row)(({ theme }) => ({
  gap: theme.spacing(theme.spacingSizes.lg),
  padding: theme.spacing(
    theme.spacingSizes.sm,
    theme.spacingSizes.xl,
    theme.spacingSizes.sm,
    theme.spacingSizes.sm,
  ),
  justifyContent: 'space-between',
  alignItems: 'center',
  alignSelf: 'stretch',
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.shape.borderRadius,
  [theme.breakpoints.down('sm')]: {
    paddingRight: theme.spacing(theme.spacingSizes.sm),
    gap: theme.spacing(theme.spacingSizes.sm),
  },
}));

const Content = styled(Column)(({ theme }) => ({
  gap: theme.spacing(theme.spacingSizes.lg),
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(theme.spacingSizes.sm),
  },
}));

const PeriodCard: React.FC<Props> = ({
  icon,
  primaryLabel,
  secondaryLabel,
  actions,
}) => {
  return (
    <Card breakpoint="sm">
      <Content>
        <Row centered spacing="xs">
          {icon}
          {primaryLabel}
        </Row>
        {secondaryLabel}
      </Content>
      {actions}
    </Card>
  );
};

export default PeriodCard;
